import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CancelSubscriptionModal = ({ isOpen, onClose, onConfirm, cancelling = false }) => {
  const [feedback, setFeedback] = useState('');
  const [selectedReason, setSelectedReason] = useState('');

  const reasons = [
    { value: 'temporary_break', label: 'J\'ai besoin d\'une pause temporaire' },
    { value: 'too_expensive', label: 'Le prix est trop eleve pour le moment' },
    { value: 'not_using_features', label: 'Je n\'utilise pas assez les fonctionnalites Pro' },
    { value: 'no_active_projects', label: 'Je n\'ai pas de projets actifs en ce moment' },
    { value: 'missing_features', label: 'Il manque des fonctionnalites dont j\'ai besoin' },
    { value: 'other', label: 'Autre raison' }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedReason) return;
    onConfirm({
      reason: selectedReason,
      reasonLabel: reasons.find(r => r.value === selectedReason)?.label || selectedReason,
      feedback: feedback.trim()
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="cancel-modal">
      <div className="bg-card border border-border rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-5 flex items-center justify-between">
          <div>
            <h2 className="text-xl md:text-2xl font-semibold" style={{ color: 'var(--color-foreground)' }}>
              Se desabonner du plan Pro
            </h2>
            <p className="text-sm mt-1" style={{ color: 'var(--color-muted-foreground)' }}>
              Vous pourrez vous reabonner a tout moment.
            </p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            iconName="X"
            onClick={onClose}
            disabled={cancelling}
          />
        </div>

        <form onSubmit={handleSubmit} className="p-5 md:p-7 space-y-6">
          <div>
            <p className="text-sm font-medium mb-4" style={{ color: 'var(--color-foreground)' }}>
              Pourquoi souhaitez-vous vous desabonner ? <span style={{ color: '#f59e0b' }}>*</span>
            </p>
            <div className="space-y-2">
              {reasons.map((reason) => (
                <label
                  key={reason.value}
                  className="flex items-start gap-3 p-3 rounded-lg border border-border cursor-pointer hover:bg-muted transition-colors"
                  data-testid={`reason-${reason.value}`}
                >
                  <input
                    type="radio"
                    name="cancellationReason"
                    value={reason.value}
                    checked={selectedReason === reason.value}
                    onChange={(e) => setSelectedReason(e.target.value)}
                    className="mt-1"
                    disabled={cancelling}
                  />
                  <span className="text-sm flex-1" style={{ color: 'var(--color-foreground)' }}>{reason.label}</span>
                </label>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2" style={{ color: 'var(--color-foreground)' }}>
              Commentaires ou suggestions (optionnel)
            </label>
            <textarea
              className="w-full min-h-[100px] px-4 py-2 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary resize-none"
              placeholder="Dites-nous ce que nous pouvons ameliorer..."
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              disabled={cancelling}
              maxLength={500}
              data-testid="cancel-feedback"
            />
            <p className="text-xs mt-1" style={{ color: 'var(--color-muted-foreground)' }}>
              {feedback.length}/500
            </p>
          </div>

          <div className="rounded-lg p-4" style={{ background: 'rgba(245,158,11,.06)', border: '1px solid rgba(245,158,11,.20)' }}>
            <div className="flex items-start gap-3">
              <Icon name="AlertCircle" size={20} style={{ color: '#f59e0b' }} className="flex-shrink-0 mt-0.5" />
              <div className="text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
                <p className="font-medium mb-1" style={{ color: 'var(--color-foreground)' }}>Ce qui se passe :</p>
                <ul className="list-disc list-inside space-y-1 ml-2">
                  <li>Votre acces Pro reste actif jusqu'a la fin de la periode en cours</li>
                  <li>Vous gardez toutes les fonctionnalites Pro jusqu'a cette date</li>
                  <li>Ensuite, vous repassez au plan Gratuit (analyses illimitees)</li>
                  <li>Vos donnees et analyses restent accessibles</li>
                  <li>Vous pouvez vous reabonner a tout moment</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 pt-4 border-t border-border">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={cancelling}
              className="flex-1"
              data-testid="keep-subscription-btn"
            >
              Garder mon abonnement Pro
            </Button>
            <Button
              type="submit"
              disabled={!selectedReason || cancelling}
              loading={cancelling}
              className="flex-1"
              style={{ background: 'rgba(239,68,68,.85)', color: 'white', borderColor: 'rgba(239,68,68,.5)' }}
              data-testid="confirm-cancel-btn"
            >
              {cancelling ? 'Desabonnement...' : 'Confirmer le desabonnement'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CancelSubscriptionModal;
